import * as React from 'react';
import { Avatar } from '@revenuewell/ui-icons';
import { Link } from '@mui/material';
import moment from 'moment';
import { useEventBus } from '../../../../../../../hooks/use-event-bus';
import { Contact } from '../../../../../../../services/api-client/contact-api';
import { EventPatientProfile } from '../../../../../../../types/event-bus';
import { Age, FamilyMember, Name, Rp } from './family-members.styles';


export type IProps = {
  familyMembers: Contact[];
};

export const FamilyMembers: React.FC<IProps> = props => {
  const { publish } = useEventBus();

  const renderAge = (contact: Contact) => {
    return (
      <Age>
        {contact.dateOfBirth ? `, ${moment().diff(contact.dateOfBirth, 'years', false)}` : ''}
      </Age>
    );
  };

  return (
    <>
      {props.familyMembers.length === 0 && <span>-</span>}
      {props.familyMembers.map((familyMember: Contact, i: number) => {
        return (
          <FamilyMember
            data-testid={`patient-widget-family-member-${familyMember.firstName}-${familyMember.lastName}`}
            key={i}
          >
            <Avatar size='m' />
            <Name
              onClick={() => {
                publish({
                  messageType: 'patientProfile',
                  data: {
                    patientId: familyMember.id
                  } as EventPatientProfile['data']
                });
              }}
            >
              {`${familyMember.firstName} ${familyMember.lastName}`}
              {familyMember.isResponsibleParty && <Rp>(RP)</Rp>}
              {renderAge(familyMember)}
            </Name>
          </FamilyMember>
        );
      })}
    </>
  );
};
